import { useEffect } from "react";

import { config } from "../config";

/**
 * Injects the Cloudflare Web Analytics beacon at runtime, but only when
 * VITE_CF_ANALYTICS_TOKEN is configured. Keeps dev/preview builds free of
 * a phantom beacon and lets us toggle analytics by env var alone.
 *
 * The beacon script is appended once on first mount and never removed
 * (Cloudflare's beacon is idempotent and stateless).
 */
const BEACON_MARKER_ATTR = "data-cf-beacon-mounted";

export default function CloudflareAnalytics() {
  useEffect(() => {
    const token = config.analyticsToken;
    if (!token) return;

    const existing = document.querySelector<HTMLScriptElement>(
      `script[${BEACON_MARKER_ATTR}="1"]`,
    );
    if (existing) return;

    const script = document.createElement("script");
    script.defer = true;
    script.src = "https://static.cloudflareinsights.com/beacon.min.js";
    script.dataset.cfBeacon = JSON.stringify({ token });
    script.setAttribute(BEACON_MARKER_ATTR, "1");
    document.head.appendChild(script);
  }, []);

  return null;
}
